import { CircularProgress } from "@mui/material";
import { useReducer, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Hbrbackarrow } from "./newComponents/Mycustomsvgicons";
import "./css/contactForm.css";
import Authaxios from "./newComponents2/Authaxios";
import { actionConsts, reducer } from "./newComponents/StateManager";
import { CustomAlertDialog } from "./newComponents/CustomAlertDialog";
import { sanitizeText } from "./newComponents/GeneralClasses";

const Feedback = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    contact: "",
  });

  const [state, dispatch] = useReducer(reducer, {
    showAlert: false,
    alertMessage: "",
  });

  const [feedbackSent, setFeedbackSent] = useState(false);
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const closePage = () => {
    if (location.state && location.state.from) {
      navigate(location.state.from);
    } else {
      navigate("/");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await Authaxios.post(
        "/notification/feedback-api/feedback",
        JSON.stringify({
          name: formData.name,
          contact: formData.contact,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          contactId: sanitizeText(formData.email),
        }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: false,
        }
      );
      setSending(false);
      setFormData({ name: "", subject: "", email: "", message: "" });
      setFeedbackSent(true);
    } catch (error) {
      dispatch({ type: actionConsts.SHOWALERT, payload: true });
      setSending(false);
      setFeedbackSent(false);
      if (!error?.response) {
        dispatch({
          type: actionConsts.ALERT_MESSAGE,
          payload: "no server response",
        });
      } else {
        dispatch({
          type: actionConsts.ALERT_MESSAGE,
          payload: error?.response?.data?.message,
        });
      }
    }
  };

  return !feedbackSent ? (
    <div className="contact-container">
      {state.showAlert && (
        <CustomAlertDialog
          alertmessage={state.alertMessage}
          handleCloseDialog={() =>
            dispatch({ type: actionConsts.SHOWALERT, payload: true })
          }
        />
      )}
      <div className="flex-spacebetween" style={{ width: "100%" }}>
        <Hbrbackarrow width={"2em"} height={"2em"} handleClick={closePage} />
        <h2>Contact Us</h2>
      </div>

      <p>
        Have a question, suggestion, or need support? We'd love to hear from
        you. Check the correctness of your email address before sending.
      </p>
      <form className="contact-form" onSubmit={handleSubmit}>
        <label>
          <h3>
            Full Name <span>*</span>
          </h3>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Your name"
          />
        </label>

        <label>
          <h3>
            Email Address<span>*</span>
          </h3>

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="you@example.com"
          />
        </label>

        <label>
          <h3>Phone Contact (optional)</h3>
          <input
            type="text"
            name="contact"
            value={formData.contact}
            onChange={handleChange}
            placeholder="e.g +233273653667"
          />
        </label>

        <label>
          <h3>
            Subject<span>*</span>
          </h3>

          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
            placeholder="Subject of your message"
          />
        </label>

        <label>
          <h3>
            Message<span>*</span>
          </h3>

          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            placeholder="Write your message here..."
            rows="5"
          />
        </label>

        <button type="submit">
          {sending ? "Sending ..." : "Send Message"}
        </button>
      </form>

      {sending && <CircularProgress />}
    </div>
  ) : (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <h4>
        {`Your feedback has been successfully sent. Due to the high volume of
        feedbacks received daily, it might take up to 48 hours to hear from us.
        Check your email inbox regularly for a reply. Thanks, Have a nice day.`}
      </h4>
    </div>
  );
};
export default Feedback;
